import './Guest.scss';
import * as React from 'react';
import { IActions } from '../../common/Auth0/store/actions/creators';
import { Checkbox, Grid } from '@material-ui/core';
import Button from '../../ui-components/Button/Button';
import { useAuth0 } from '../../common/Auth0/react-auth0-spa';
import { invokeApi } from '../../common/networking/invoker';

export const Guest = (props: IActions) => {

    const { logout, user } = useAuth0();
    const [confirm, setConfirm] = React.useState(false);
    const [confirm2, setConfirm2] = React.useState(false);
    const { navigateTo } = props;

    const goToOblivion = async () => {
        if (user && confirm && confirm2) {
            await invokeApi({
                path: '/api/users/' + user.sub + '/oblivion/',
                method: 'DELETE',
                responseType: 'json'
            }).then(resp => {
                console.info("--------------> goToOblivion RESPONSE", resp)
            })
            logOut();
        }
    }

    const logOut = () => {
        logout();
        navigateTo('/login');
    }

    const changeConfirmation = () => {
        setConfirm(!confirm);
    }

    const changeConfirmation2 = () => {
        setConfirm2(!confirm2);
    }
    
    const render = () => {
        console.log("render", user)
        if (!user) {
            return <></>
        }
        return <span>
            nome: <b>{user.given_name ?? ''}</b><br />
            cognome: <b>{user.family_name ?? ''}</b><br />
            mail: <b>{user.email}</b><br />
            sub: <b>{user.sub}</b><br />
        </span>;
    }

    // const { id } = this.props.match.params;
    // const { classes } = this.props;
    return (
        <div className='guest-container' style={{ border: '1px solid red' }}>
            <Grid container spacing={1}>
            </Grid>
            <Grid item xs={12}>
                <div style={{ display: 'grid', textAlign: 'left' }}>
                    AREA PUBBLICA
                    <br />
                    {render()}
                </div>
                {/* <div>user:{JSON.stringify(user)}</div> */}
                <div>
                    <p>Benvenuto!</p>
                    <p>Vuoi eliminare definitivamente l'account?</p>
                    <p>Confermo!
                        <Checkbox
                            disabled={false}
                            checked={confirm}
                            onChange={changeConfirmation}
                            value="1"
                            color="primary"
                        />
                    </p>
                    {confirm && <p>Attenzione! <br />
                        Non sarà più possibile recuperare l'account e tutte le informazioni collegate. <br />
                        Sei sicuro?
                        <Checkbox
                            disabled={false}
                            checked={confirm2}
                            onChange={changeConfirmation2}
                            value="1"
                            color="primary"
                        />
                    </p>}
                    <br />
                    <Button disabled={!(confirm && confirm2)} onClick={goToOblivion}>ELIMINA</Button>
                </div>
            </Grid>
            <Button onClick={logOut}>Logout</Button>
        </div>
    );
}